import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { audioManager } from '../utils/audioManager';
import { soundManager } from '../utils/soundManager';


export const useGroupChatSound = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    // Listen for new group chat messages
    const handleNewGroupMessage = (event: CustomEvent) => {
      const { senderId, senderName } = event.detail;

      // Don't play sound for own messages
      if (senderId === user.id) {
        console.log('🚫 Not playing group chat sound for own message');
        return;
      }

      console.log(`🔊 Playing group chat notification sound from ${senderName}`);
      audioManager.playNotificationSound('groupMessage');
      soundManager.playGroupNotification();
    };

    // Listen for the event
    window.addEventListener('newGroupMessage', handleNewGroupMessage as EventListener);

    return () => {
      window.removeEventListener('newGroupMessage', handleNewGroupMessage as EventListener);
    };
  }, [user]);

  return {
    playSound: () => audioManager.playNotificationSound('groupMessage')
  };
};